/**
 * @constructor
 */
function XsollaApi() {

    var $ = jQuery;

    var XPayStationWidget;
    var _buyCallback;

    /**
     * @param {Object} params
     * @param {String} params.token
     * @param {Boolean} [params.debug]
     * @param {SocialCallback} callback
     */
    this.buy = function (params, callback) {
        if (XPayStationWidget) {
            XPayStationWidget.init({'access_token': params.token, 'sandbox': params.debug});
            XPayStationWidget.open();
            if (_buyCallback) {
                _buyCallback.error("XsollaApi.buy.userCancelled");
            }
            _buyCallback = callback;
        } else {
            callback.error("XPayStationWidget not available");
        }
    };

    initialize();

    function onPaymentStatusDone(event, data) {
        if (_buyCallback) {
            _buyCallback.success();
            _buyCallback = null;
        }
    }

    function initialize() {
        $.getScript('//static.xsolla.com/embed/paystation/1.0.7/widget.min.js')
            .done(function () {
                XPayStationWidget = window.XPayStationWidget;
                XPayStationWidget.on(XPayStationWidget.eventTypes.STATUS_DONE, onPaymentStatusDone);
            })
            .fail(function (jqxhr, settings, exception) {
                var message = "Error loading xsolla payment widget: ";
                if (jqxhr.readyState === 0) {
                    //script failed to load
                    message += "script failed to load";
                } else {
                    //script loaded but failed to parse
                    message += "script loaded but failed to parse, exception = ";
                    message += exception;
                }
                Logger.error('XsollaApi.initialize', message);
            });
    }

}